module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overlay-news",
    class: _vm.isOpenOverlay ? 'open' : ''
  }, [_c('div', {
    staticClass: "overlay-head"
  }, [_c('div', {
    staticClass: "back-btn",
    on: {
      "click": _vm.close
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/arrow-back@2x.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("Back")])])]), _vm._v(" "), _c('div', {
    staticClass: "overlay-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "border-grid"
  }), _vm._v(" "), _c('h3', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('message.news')[_vm.indexNews].overlay_title)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('message.news')[_vm.indexNews].overlay_subtitle)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('message.news')[_vm.indexNews].overlay_text)
    }
  }), _vm._v(" "), (_vm.$t('message.news')[_vm.indexNews].overlay_img_extra.length > 0) ? _c('img', {
    staticClass: "img-webinar",
    attrs: {
      "src": require('../../assets/images/' +
        _vm.$t('message.news')[_vm.indexNews].overlay_img_extra)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$t('message.news')[_vm.indexNews].overlay_text_extra.length > 0) ? _c('p', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('message.news')[_vm.indexNews].overlay_text_extra)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$t('message.news')[_vm.indexNews].overlay_img.length > 0) ? _c('img', {
    staticClass: "img-webinar",
    attrs: {
      "src": require('../../assets/images/' +
        _vm.$t('message.news')[_vm.indexNews].overlay_img)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$t('message.news')[_vm.indexNews].overlay_filename.length > 0) ? _c('div', {
    staticClass: "download"
  }, [_c('a', {
    attrs: {
      "href": _vm.$t('message.news')[_vm.indexNews].overlay_filename_path,
      "download": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/download-icon@2x.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("message.news")[_vm.indexNews].overlay_filename))])])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34caab01","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/OverlayNews.vue
// module id = 336
// module chunks = 0